import { z } from "zod";
import { updatedBySchema } from "@qivia/schemas-shared";

export const activateTelemetryForVehiclesPayload = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      updatedBy: updatedBySchema,
    }),
  ),
});

export type ActivateTelemetryForVehiclesPayload = z.infer<
  typeof activateTelemetryForVehiclesPayload
>;
